import ssa_110_1 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_1.pdf";
import ssa_110_2 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_2.pdf";
import ssa_110_3 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_3.pdf";
import ssa_110_4 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_4.pdf";
import ssa_110_5 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_5.pdf";
import ssa_110_6 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_6.pdf";
import ssa_110_7 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_7.pdf";
import ssa_110_8 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_8.pdf";
import ssa_110_9 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_9.pdf";
import ssa_110_10 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_10.pdf";
import ssa_110_11 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_11.pdf";
import ssa_110_12 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_12.pdf";
import ssa_110_13 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_13.pdf";
import ssa_110_14 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_14.pdf";
import ssa_110_15 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_15.pdf";
import ssa_110_16 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_16.pdf";
import ssa_110_17 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_17.pdf";
import ssa_110_18 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_18.pdf";
import ssa_110_19 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_19.pdf";
import ssa_110_20 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_20.pdf";
import ssa_110_21 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_21.pdf";
import ssa_110_22 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_22.pdf";
import ssa_110_23 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_23.pdf";
import ssa_110_24 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_24.pdf";
import ssa_110_25 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_25.pdf";
import ssa_110_26 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_26.pdf";
import ssa_110_27 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_27.pdf";
import ssa_110_28 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_28.pdf";
import ssa_110_29 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_29.pdf";
import ssa_110_30 from "@/assets/studentAwardsRouter/studentAwardsFile/110/ssa_110_30.pdf";

var awardsPath_110 = [
  ssa_110_1,
  ssa_110_2,
  ssa_110_3,
  ssa_110_4,
  ssa_110_5,
  ssa_110_6,
  ssa_110_7,
  ssa_110_8,
  ssa_110_9,
  ssa_110_10,
  ssa_110_11,
  ssa_110_12,
  ssa_110_13,
  ssa_110_14,
  ssa_110_15,
  ssa_110_16,
  ssa_110_17,
  ssa_110_18,
  ssa_110_19,
  ssa_110_20,
  ssa_110_21,
  ssa_110_22,
  ssa_110_23,
  ssa_110_24,
  ssa_110_25,
  ssa_110_26,
  ssa_110_27,
  ssa_110_28,
  ssa_110_29,
  ssa_110_30,
];

export { awardsPath_110 };
